// @flow
import type { Action } from 'app/common/redux/types';

export type ReportData = {|
  id: string,
  isPromoted: boolean,
  videoDuration: ?number,
  viewParameter: ?number,
  viewType: ?number,
  type: 'pin' | 'board' | 'aggregatedComment',
|};

export type State = ?ReportData;

const reportData = (state: State = null, action: Action): State => {
  switch (action.type) {
    case 'REPORT_CONTENT_SHOW':
      return {
        id: action.payload.id,
        isPromoted: action.payload.isPromoted,
        videoDuration: action.payload.videoDuration,
        viewParameter: action.payload.viewParameter,
        viewType: action.payload.viewType,
        type: action.payload.type,
      };
    case 'REPORT_CONTENT_DISMISS':
      return null;
    default:
      return state;
  }
};

export default reportData;
